import { createSlice } from "@reduxjs/toolkit";

interface ViewState {
  viewId: {
    selectedViewId: number | null;
    defaultViewId: number | null;
  }
}

const initialState: ViewState = {
  viewId: {
    selectedViewId: null,
    defaultViewId: null,
  }
};

const viewIdSlice = createSlice({
  name: "viewIdDetailsAboAssignment",
  initialState,
  reducers: {
    updateViewAboAssignmentId: (state, action) => {
      state.viewId = { ...action.payload.viewIdDetailsAboAssignment };
    },
  },
});

export const { updateViewAboAssignmentId } = viewIdSlice.actions;
export default viewIdSlice.reducer;
